const hi = {
  contact: {
    heroHeading: 'संपर्क करें',
    heroSub: 'चाहे आप खरीद रहे हों, बेच रहे हों, या निवेश कर रहे हों — हमारी टीम हर कدम पर आपकी मदद के लिए तैयार है।',
    expertsBadge: 'हमारे विशेषज्ञों से मिलें',
    expertsHeading: 'Victory Homes के पीछे के लोग',
    officeLabel: 'कार्यालय स्थान',
    phoneLabel: 'फ़ोन नंबर',
    phoneOffice: 'कार्यालय',
    phoneWA: 'कॉल / वॉट्सएप',
    emailLabel: 'ईमेल करें',
    followLabel: 'फ़ॉलो करें',
    formHeading: 'हमें संदेश भेजें',
    formSub: 'नीचे फ़ॉर्म भरें, हमारी टीम 24 घंटे के भीतर जवाब देगी।',
    fieldName: 'आपका नाम *',
    fieldEmail: 'ईमेल पता *',
    fieldPhone: 'फ़ोन नंबर',
    fieldSubject: 'विषय',
    fieldMessage: 'आपका संदेश *',
    sendBtn: 'संदेश भेजें',
    sentBtn: '\u2713 संदेश भेज दिया!',
    thankYou: 'धन्यवाद! हम 24 घंटे में जवाब देंगे।',
  },
  mort: {
    heroBadge: 'होम लोन सेवाएं',
    heroLine1: 'UAE मॉर्गेज समाधान',
    heroAccent: 'आपके लिए अनुकूलित',
    heroSub: 'अपनी EMI गणना करें, पात्रता जांचें, और 15+ UAE बैंकों के उत्पाद खोजें — एक स्थान पर।',
    tabCalc: '📊 होम लोन कैलकुलेटर',
    tabElig: '✅ पात्रता जांच',
    loanParams: 'लोन पैरामीटर',
    propertyValue: 'संपत्ति मूल्य',
    downPayment: 'डाउन पेमेंट',
    annualRate: 'वार्षिक ब्याज दर',
    loanTenure: 'लोन अवधि',
    years: (n) => `${n} वर्ष`,
    minDown: '20% (न्यूनतम)',
    maxUAE: '25 वर्ष (UAE अधिकतम)',
    monthlyEMI: 'मासिक EMI',
    loanAmount: 'लोन राशि',
    totalInterest: 'कुल ब्याज',
    totalPayable: 'कुल भुगतान',
    principalVsInterest: 'मूलधन बनाम ब्याज',
    principal: 'मूलधन',
    interest: 'ब्याज',
    compareRates: '🏦 UAE बैंक दरों की तुलना',
    amortSchedule: '📅 वार्षिक अमोर्प्डाइजेशन शेड्यूल',
    basedOnLoan: (amt, yrs) => `AED ${amt} के लोन पर ${yrs} वर्षों के लिए। दर सांकेतिक हैं।`,
    bankCol: 'बैंक',
    fixedRate3yr: 'निश्चित दर (3 वर्ष)',
    variableEIBOR: 'परिवर्तनीय (EIBOR+)',
    monthlyEMIFixed: 'मासिक EMI (निश्चित)',
    totalCost: 'कुल लागत',
    eibor3mNote: (rate) => `* EIBOR 3M: ${rate}% (संदर्भ दर)।`,
    yearCol: 'वर्ष',
    principalPaid: 'मूलधन भुगतान',
    interestPaid: 'ब्याज भुगतान',
    balanceRemaining: 'शेष बाकी',
    yearRow: (n) => `वर्ष ${n}`,
    financialProfile: 'आपकी वित्तीय प्रोफ़ाइल',
    residencyStatus: 'निवास स्थिति',
    residencyOpts: [
      { value: 'resident',    label: '🏠 UAE निवासी',   desc: '80% LTV · 25 वर्ष' },
      { value: 'national',    label: '🇦🇪 UAE नागरिक',  desc: '85% LTV · 25 वर्ष' },
      { value: 'nonresident', label: '✈️ अनिवासी',  desc: '50% LTV · 15 वर्ष' },
    ],
    yourAge: 'आपकी आयु',
    ageUnit: 'वर्ष',
    monthlySalary: 'मासिक वेतन (AED)',
    otherIncome: 'अन्य मासिक आय',
    existingEMI: 'मौजूदा लोन EMI (AED/माह)',
    creditCard: 'क्रेडिट कार्ड सीमा (AED)',
    ccNote: 'बैंक सीमा का 5% मासिक बोझ मानते हैं',
    assumedRate: 'अनुमानित ब्याज दर',
    checkBtn: '🔍 पात्रता जांचें',
    fillDetails: 'विवरण भरें',
    fillDesc: 'UAE सेंट्रल बैंक DBR नियमों के आधार पर हम आपकी अधिकतम पात्र लोन राशि गणना करेंगे।',
    errTitle: 'पात्रता गणना संभव नहीं',
    errDesc: 'आपकी मौजूदा देनदारियां DBR 50% सीमा से अधिक हो सकती हैं। कृपया सलाहकार से संपर्क करें।',
    maxLoan: 'अधिकतम लोन राशि',
    maxProperty: 'अधिकतम संपत्ति मूल्य',
    minDownPay: 'न्यूनतम डाउन पेमेंट',
    maxTenure: 'अधिकतम लोन अवधि',
    maxEMI: 'अधिकतम अनुमत EMI',
    dbrTitle: 'UAE सेंट्रल बैंक DBR विश्लेषण',
    grossIncome: 'कुल मासिक आय',
    existingObligs: 'मौजूदा देनदारियां',
    dbrHeadroom: 'DBR हेडरूम (50%)',
    ltvApplied: 'लागू LTV',
    dbrNote: 'परिणाम सांकेतिक हैं। वास्तविक पात्रता बैंक मूल्यांकन और क्रेडिट स्कोर पर निर्भर करती है।',
    readyApply: 'आवेदन के लिए तैयार?',
    readyApplyDesc: 'हमारे सलाहकार 15+ UAE बैंकों में से सर्वश्रेष्ठ दर सुरक्षित करेंगे।',
    talkAdvisor: 'सलाहकार से बात करें →',
    servicesBadge: 'हमारी सेवाएं',
    servicesHeading: 'एक ही छत के नीचे सब कुछ',
    servicesSub: 'Victory Homes UAE के प्रमुख बैंकों के साथ मिलकर पारदर्शी मॉर्गेज सेवाएं देती है।',
    services: [
      { icon: '🏠', title: 'आवासीय मॉर्गेज', desc: 'शीर्ष बैंकों से प्रतिस्पर्धी दरों पर UAE में अपने सपनों का घर फाइनेंस करें।' },
      { icon: '✈️', title: 'अनिवासी मॉर्गेज', desc: 'UAE में निवेश करना चाहते हैं? हम 50% LTV तक व्यवस्था करते हैं।' },
      { icon: '🔄', title: 'लोन बदलाव / इक्विटी रिलीज़', desc: 'मौजूदा मॉर्गेज पर ज़्यादा भुगतान? बैंक बदलें और हज़ारों बचाएं।' },
      { icon: '🏗️', title: 'भूमि और निर्माण', desc: 'ऑफ़-प्लान निर्माण के लिए विशेष उत्पादों से भूमि फ़ायनेंस।' },
      { icon: '📋', title: 'मुफ्त पात्रता मूल्यांकन', desc: 'आपकी प्रोफ़ाइल का मूल्यांकन कर 5+ बैंकों ने प्री-क्वालिफ़िकेशन पत्र देते हैं।' },
      { icon: '👤', title: 'व्यक्तिगत सलाहकार', desc: 'प्रत्येक ग्राहक को समर्पित सलाहकार मिलता है।' },
    ],
    ctaHeading: 'अगला कदम उठाने के लिए तैयार?',
    ctaSub: 'हमारे सलाहकार सर्वश्रेष्ठ सौदा सुरक्षित करने में मदद करते हैं। मुफ्त परामर्श।',
    ctaBtn: 'मुफ्त परामर्श बुक करें →',
  },
  offplan: {
    heroBadge: '\u2726 दुबई ऑफ़-प्लान संपत्तियाँ',
    heroLine1: 'निवेश करें पहले',
    heroAccent: 'शहर आगे बढ़े.',
    heroSub: 'दुबई के सबसे लोकप्रिय विकासों तक अनन्य पहुंच। आज की कीमतों पर प्रमुख इकाइयाँ सुरक्षित करें।',
    browseBtn: 'प्रोजेक्ट देखें',
    advisorBtn: 'सलाहकार से बात करें',
    statGrowth: 'औसत पूंजी वृद्धि',
    statVisa: 'गोल्डन विज़ा सीमा',
    statComm: 'खरीदार को कमीशन',
    whyBadge: 'ऑफ़-प्लान क्यों',
    whyHeading: 'समझदार निवेशक की पसंद',
    why: [
      { icon: '\ud83d\udcb0', title: 'कम प्रवेश कीमत', desc: 'बाज़ार मूल्य से 20-30% कम कीमतों पर खरीदें।' },
      { icon: '\ud83d\udcc5', title: 'लचीली भुगतान योजनाएँ', desc: 'डेवलपर 40/60 या 20/80 भुगतान योजनाएँ प्रदान करते हैं।' },
      { icon: '\ud83d\udcc8', title: 'पूंजी वृद्धि', desc: 'दुबई ऑफ़-प्लान ने ऐतिहासिक रूप से 30-50% वृद्धि दी है।' },
      { icon: '\ud83e\ude99', title: 'गोल्डन विज़ा पात्र', desc: 'AED 2M+ संपत्तियाँ 10-वर्षीय गोल्डन विज़ा के लिए पात्र हैं।' },
    ],
    featuredBadge: 'चुनिंदा विकास',
    featuredHeading: 'चुने गए ऑफ़-प्लान प्रोजेक्ट',
    catalogueLink: 'पूरा कैटालॉग मंगाएं \u2192',
    showingOf: (shown, total) => `${shown} में से ${total} प्रोजेक्ट`,
    noMatchTitle: 'कोई मेल खाती संपत्ति नहीं मिली',
    noMatchDesc: 'ज़्यादा परिणाम दिखाने के लिए फ़िल्टर एडजस्ट करें।',
    clearFilters: 'सभी फ़िल्टर हटाएं',
    communitiesBadge: 'क्षेत्र खोजें',
    communitiesHeading: 'दुबई के सबसे आकर्षक क्षेत्र',
    seeListings: 'सभी लिस्टिंग देखें \u2192',
    locations: [
      { name: 'Downtown', desc: ['दुबई के केंद्र में, डाउनटाउन शहरी जीवन का सार है।', 'विशाल लाउंज और पैनोरमिक तरासे।'] },
      { name: 'Palm Jumeirah', desc: ['विरासत और आधुनिक कला का संजोग।', 'शांत बाहरी स्थान और आरामदायक जीवनशैली।'] },
      { name: 'Marina', desc: ['नगरीय जीवनशैली और जलतटीय वैभव का संगम।', 'निजी मरीना और सुंदर बोर्डवॉक।'] },
      { name: 'Dubai Hills', desc: ['प्रकृति और शहरी सौंदर्य का संगम।', 'स्वास्थ्य और अनुग्रह से भरी जीवनशैली।'] },
      { name: 'Arabian Ranches', desc: ['शानदार फ़िला और हरियत से भरपूर परिवेश।', 'गोल्फ कोर्स और परिवार-केंद्रित परिसर।'] },
    ],
  },
  sell: {
    heroBadge: 'अपनी संपत्ति सूचीबद्ध करें',
    heroHeadline: 'साथ जुड़ें',
    heroAccent: 'Victory Homes',
    heroSub: 'हमारी विशेषज्ञ टीम के साथ अपनी संपत्ति सूचीबद्ध करें। हम मूल्यांकन से समापन तक सब संभालते हैं।',
    formBadge: 'संपत्ति मालिकों के लिए',
    formHeading: 'अपनी संपत्ति हमारे साथ सूचीबद्ध करें',
    formSub: 'फॉर्म भरें और हमारी धैर्यवान टीम सब कुछ संभालेगी — मूल्यांकन से समापन तक।',
    tabSell: '🏷️ बेचें',
    tabRent: '🔑 किराया',
    sectionContact: 'संपर्क जानकारी',
    sectionProperty: 'संपत्ति विवरण',
    sectionDocs: 'कानूनी दस्तावेज़',
    sectionPhotos: 'संपत्ति फ़ोटो',
    fullName: 'पूरा नाम',
    email: 'ईमेल पता',
    phone: 'फ़ोन नंबर',
    whatsapp: 'वॉट्सएप (वैकल्पिक)',
    propertyType: 'संपत्ति प्रकार',
    selectType: '— प्रकार चुनें —',
    emirate: 'इमारेट',
    selectEmirate: '— इमारेट चुनें —',
    community: 'कॉम्युनिटी / क्षेत्र',
    subCommunity: 'उप-क्षेत्र / मकान',
    bedrooms: 'शयन कक्ष',
    bathrooms: 'स्नानघर',
    select: '— चुनें —',
    areaSqFt: 'क्षेत्रफल (वर्ग फ़ुट)',
    floor: 'मंज़िल / स्तर',
    furnishing: 'फर्निशिंग',
    completion: 'पूर्णता',
    ready: 'तैयार',
    offPlan: 'ऑफ़-प्लान',
    askingPrice: 'मांगी गई कीमत',
    rentAmount: 'किराया राशि (प्रति वर्ष)',
    priceHint: 'राशि बिना कॉमा के दर्ज करें। कीमत वर्तमान बाज़ार मूल्य के अनुसार होनी चाहिए।',
    youtubeLink: 'यूट्यूब वीडियो लिंक',
    youtubeHint: 'अपनी संपत्ति दिखाने के लिए एक यूट्यूब लिंक जोड़ें (वैकल्पिक)',
    description: 'संपत्ति विवरण',
    descPlaceholder: 'अपनी संपत्ति का विवरण दें — विशेषताएँ, दृश्य, सुधार, नजदीकी सुविधाएँ…',
    docsIntro: 'ये दस्तावेज़ मालिकाना सत्यापित करते हैं। सभी फ़ाइलें सुरक्षित हैं।',
    titleDeed: 'स्वामित्व दस्तावेज़',
    titleDeedHint: 'सरकारी स्वामित्व दस्तावेज़।',
    floorPlan: 'फ्लोर प्लान',
    floorPlanHint: 'वास्तुकला फ्लोर प्लान।',
    passport: 'पासपोर्ट कॉपी',
    passportHint: 'संपत्ति मालिक का वैध पासपोर्ट।',
    privacy: 'गोपनीयता गारंटीरासह सुरक्षित। आपके दस्तावेज़ एन्क्रिप्टेड हैं।',
    photosLabel: 'संपत्ति फ़ोटो',
    photosHint: 'अधिकतम 20 चित्र — JPG, PNG, WEBP। पहला चित्र कवर होगा।',
    photosIntro: 'अच्छी फ़ोटो हीं ज्यादा पूछताछ लाती हैं। हर कमरे की विशाल-कोण फ़ोटो लें।',
    dragDrop: 'खींचें या',
    browse: 'ब्राउज़ करें',
    accepted: 'PDF, JPG, PNG स्वीकार्य',
    clickReplace: 'बदलने के लिए क्लिक करें',
    dropPhotos: 'फ़ोटो यहाँ ड्रॉप करें',
    orClickBrowse: 'या ब्राउज़ करने के लिए क्लिक करें',
    upTo20: 'अधिकतम 20 चित्र',
    photosAdded: (n) => `${n} फ़ोटो जोड़ी गई`,
    submitSale: '🚀 बिक्री लिस्टिंग जमा करें',
    submitRental: '🚀 किराया लिस्टिंग जमा करें',
    submitting: '⏳ जमा हो रहा है…',
    termsNotice: 'जमा करने पर, आप Victory Homes की सेवा शर्तों से सहमत होते हैं।',
    successTitle: 'लिस्टिंग जमा हुई!',
    successDesc: 'हमारी टीम समीक्षा करेगी और',
    successHours: '24 घंटे',
    submitAnother: 'अन्य जमा करें',
    errName: 'पूरा नाम आवश्यक है',
    errEmail: 'वैध ईमेल आवश्यक है',
    errPhone: 'फ़ोन नंबर आवश्यक है',
    errPropType: 'संपत्ति प्रकार चुनें',
    errEmirate: 'इमारेट चुनें',
    errPrice: 'मांगी गई कीमत आवश्यक है',
    errRent: 'किराया राशि आवश्यक है',
    errPhotos: 'कम से कम एक फ़ोटो आवश्यक है',
  },
  props: {
    heroBadge: 'UAE संपत्तियाँ',
    listingCount: (n) => `${n} लिस्टिंग उपलब्ध`,
    tabBuy: 'खरीदें',
    tabRent: 'किराया',
    portfolio: 'हमारा पोर्टफोलियो',
    forSale: 'बिक्री के लिए संपत्तियाँ',
    forRent: 'किराए के लिए संपत्तियाँ',
    listYourProperty: 'अपनी संपत्ति सूचीबद्ध करें →',
    buy: {
      badge: 'बिक्री के लिए संपत्तियाँ',
      headline: 'अपनी आदर्श',
      accent: 'संपत्ति खरीदें',
      sub: 'UAE में हमारी विशेषज्ञ टीम द्वारा स्वीकृत सालाना लिस्टिंग खोजें।',
    },
    rent: {
      badge: 'किराए के लिए संपत्तियाँ',
      headline: 'अपना आदर्श',
      accent: 'किराया संपत्ति खोजें',
      sub: 'Victory Homes द्वारा चुनी गई दुबई और इमारेट्स में गुणवत्तापूर्ण किराया लिस्टिंग देखें।',
    },
    enquireNow: 'अभी पूछताछ करें →',
    noMatchTitle: 'आपके फ़िल्टर से कोई लिस्टिंग मेल नहीं खाती',
    noMatchDesc: 'अधिक परिणाम देखने के लिए बजट, प्रकार या क्षेत्र अडजस्ट करें।',
    clearFilters: 'सभी फ़िल्टर हटाएं',
    emptyBuy: 'वर्तमान में बिक्री के लिए कोई संपत्ति सूचीबद्ध नहीं',
    emptyRent: 'वर्तमान में किराए के लिए कोई संपत्ति सूचीबद्ध नहीं',
    emptyDesc: () => 'हमारा पोर्टफोलियो नियमित रूप से अपडेट होता है — कृपया जल्द ही पुनः जाँचें या सीधे संपर्क करें।',
    speakAgent: 'एजेंट से बात करें →',
    listProp: 'अपनी संपत्ति सूचीबद्ध करें',
    exploreOther: 'अन्य संपत्तियाँ देखें',
    otherForSale: 'बिक्री के लिए अन्य उपलब्ध संपत्तियाँ',
    otherForRent: 'किराए के लिए अन्य उपलब्ध संपत्तियाँ',
    otherDesc: 'हमारे पोर्टफोलियो से कुछ अन्य संपत्तियाँ उपलब्ध हैं।',
    ctaBadge: 'सूचीबद्ध करने के लिए तैयार?',
    ctaHeading: 'क्या आपके पास सूचीबद्ध करने के लिए संपत्ति है?',
    ctaDesc: 'हमारे विशेषज्ञ ब्रोकर मूल्यांकन से समापन तक सब कुछ संभालते हैं। आज ही Victory Homes के साथ अपनी संपत्ति सूचीबद्ध करें।',
    contactUs: 'संपर्क करें',
  },
  featured: {
    tag: 'एक्सक्लूसिव संपत्तियाँ',
    heading: 'Emirates के साथ एक्सक्लूसिव संपत्तियाँ खोजें',
    desc: 'Emirates के साथ शानदार घरों और प्रमुख रियल एस्टेट अवसरों का बेहतरीन चुनाव खोजें। उस जीवन में कदम रखें जिसके आप हकदार हैं।',
  },
  partners: {
    tag: 'हमारे पार्टनर',
    heading: 'UAE के प्रमुख डेवलपर्स की संपत्तियाँ',
    learnMore: 'अधिक जानें',
    learnMoreArrow: 'अधिक जानें →',
    oasis: { title: 'ओएसिस गार्डन विला', desc: 'निजी बगीचों, छायादार आंगनों और प्रकृति-प्रेरित डिज़ाइन के साथ विशाल आधुनिक घर — शांति, सुंदरता और पारिवारिक जीवन के लिए।' },
    ghaf:  { title: 'घाफ वुड्स, दुबई', desc: 'पारिस्थितिक घरों, पैदल-अनुकूल स्थानों और प्रचुर हरियाली के साथ कम घनत्व वाला आवासीय परिसर — स्वास्थ्य और दीर्घकालिक जीवन के लिए।' },
    nad:   { title: 'नद अल शेबा', desc: 'एकांत वातावरण में विशाल विला के साथ एक विशेष आवासीय जिला, गोपनीयता, हरियाली और दुबई के प्रमुख स्थलों की निकटता के लिए प्रसिद्ध।' },
    district: { title: 'डिस्ट्रिक्ट वन, दुबई', desc: 'क्रिस्टल लैगून और हरे-भरे स्थानों के बीच सुंदर विला और मैंशन के साथ अल्ट्रा-लग्जरी नियोजित समुदाय — गोपनीयता और प्रतिष्ठा के लिए।' },
  },
  media: {
    tag: 'मीडिया कवरेज',
    heading: 'समाचारों में विशेष रूप से प्रकाशित',
    readArticle: 'लेख पढ़ें',
  },
  newsletter: {
    badge: 'अपडेट रहें',
    heading: 'दुबई के संपत्ति बाज़ार से आगे रहें',
    desc: 'एक्सक्लूसिव लिस्टिंग, बाज़ार की जानकारी और निवेश के अवसर सीधे आपके इनबॉक्स में — बाज़ार में आने से पहले।',
    placeholder: 'अपना ईमेल पता दर्ज करें',
    btn: 'सब्सक्राइब करें →',
    privacy: '🔒 कोई स्पैम नहीं। कभी भी अनसब्सक्राइब करें। आपका डेटा सुरक्षित है।',
    success: '✓ आप सब्सक्राइब हो गए! Victory Homes समुदाय में आपका स्वागत है।',
    error: 'कृपया एक वैध ईमेल पता दर्ज करें।',
  },
  nav: {
    home: 'होम', properties: 'संपत्तियाँ', buy: '🏡 खरीदें', rent: '🔑 किराया',
    sellRent: 'बेचें/किराया', offplan: 'ऑफ-प्लान', services: 'सेवाएं',
    holidayHomes: 'हॉलिडे होम्स', propertyManagement: 'संपत्ति प्रबंधन',
    fitOut: 'रेनोवेशन, होम शिफ्टिंग और पैकर्स',
    legalAssistance: 'कानूनी सहायता',
    valuation: 'संपत्ति मूल्यांकन',
    calculators: 'होम लोन',
    transactions: 'लेनदेन',
    mortgage: 'होम लोन कैलकुलेटर', contact: 'संपर्क करें', roiCalc: 'ROI कैलकुलेटर',
    areaIntelligence: 'क्षेत्र विश्लेषण',
  },
  valuation: {
    heroTitle: 'मुफ्त बाजार संपत्ति मूल्यांकन',
    heroDesc: 'बेचने की सोच रहे हैं? हमारे विशेषज्ञों से अपनी संपत्ति के वर्तमान बाजार मूल्य का त्वरित मूल्यांकन प्राप्त करें।',
    successTitle: 'अनुरोध प्राप्त हुआ!',
    successDesc: 'हमारे मूल्यांकन विशेषज्ञ आपकी संपत्ति के विवरण की समीक्षा करेंगे और जल्द ही आपसे संपर्क करेंगे।',
    submitAnother: 'एक और अनुरोध भेजें',
    fullName: 'पूरा नाम *',
    phone: 'फ़ोन नंबर *',
    email: 'ईमेल पता',
    propType: 'संपत्ति का प्रकार *',
    selectType: 'प्रकार चुनें',
    location: 'स्थान / समुदाय *',
    locPlaceholder: 'उदा: दुबई मरीना',
    bedrooms: 'बेडरूम',
    select: 'चुनें',
    area: 'निर्मित क्षेत्र (Sq.Ft)',
    areaPlaceholder: 'उदा: 1500',
    submit: 'मेरा मुफ्त मूल्यांकन प्राप्त करें',
    submitting: 'सबमिट हो रहा है...',
    fail: 'अनुरोध सबमिट करने में विफल। कृपया पुनः प्रयास करें।'
  },
  recentlySold: {
    title: 'हाल ही में बेची गई संपत्तियां',
    desc: 'हमारे नवीनतम सफल लेनदेन का चयन। विक्ट्री होम्स का अनुभव करें।',
    badge: 'बिक गया',
    beds: 'बेड्स'
  },
  trust: {
    clientStories: 'ग्राहक की कहानियां',
    hearFromClients: 'हमारे ग्राहकों से सुनें',
    videoUnavailable: 'वीडियो अनुपलब्ध',
    trackRecord: 'ट्रैक रिकॉर्ड',
    provenSuccess: 'प्रमाणित सफलता'
  },
  areaIntelligence: {
    heroBadge: 'दुबई क्षेत्र विश्लेषण',
    heroLine1: 'डेटा-आधारित जानकारी',
    heroAccent: 'दुबई के हर क्षेत्र के लिए।',
    heroSub: 'दुबई के सबसे लोकप्रिय समुदायों में कीमत रुझान, किराया उपज और AI निवेश विश्लेषण देखें।',
    modeBuy: 'खरीदें',
    modeRent: 'किराया',
    modeOffplan: 'ऑफ-प्लान',
    filterTitle: 'फ़िल्टर और मेट्रिक्स',
    heatmapLabel: 'मानचित्र मेट्रिक',
    chartAreasLabel: 'चार्ट क्षेत्र',
    selectAll: 'सभी',
    selectNone: 'कोई नहीं',
    loading: 'क्षेत्र डेटा लोड हो रहा है…',
    mapsKeyMissing: 'Google Maps API कुंजी आवश्यक है',
    mapsKeyHint: 'VITE_GOOGLE_MAPS_API_KEY को अपनी .env फ़ाइल में जोड़ें और पुनः लोड करें।',
    mapFailedLoad: 'मानचित्र लोड नहीं हुआ। API कुंजी जांचें।',
    mapLoading: 'मानचित्र लोड हो रहा है…',
    legendSelectedArea: '⬤ चयनित क्षेत्र',
    legendSelectedDesc: 'सफ़ेद बुलबुला = आपका सक्रिय चयन',
    legendLow: { avgPrice: 'कम कीमत', rentalYield: 'कम उपज', demandScore: 'कम मांग', avgPricePerSqft: 'कम कीमत/वर्ग फुट' },
    legendHigh: { avgPrice: 'अधिक कीमत', rentalYield: 'अधिक उपज', demandScore: 'अधिक मांग', avgPricePerSqft: 'अधिक कीमत/वर्ग फुट' },
    activeProjects: 'सक्रिय परियोजनाएं',
    nearbyLandmarks: '📍 नज़दीकी स्थल',
    kpiAvgPrice: 'औसत कीमत',
    kpiPricePerSqft: 'कीमत / वर्ग फुट',
    kpiGrossYield: 'सकल उपज',
    kpiDemandScore: 'मांग स्कोर',
    aiInsightTitle: '✦ AI बाज़ार विश्लेषण',
    aiGenerate: 'तैयार करें →',
    aiAnalysing: 'बाज़ार डेटा का विश्लेषण हो रहा है…',
    aiKeyMissing: 'AI विश्लेषण के लिए backend/.env में GEMINI_API_KEY जोड़ें।',
    aiPrompt: 'इस क्षेत्र के लिए AI-आधारित निवेश विश्लेषण हेतु "तैयार करें" क्लिक करें।',
    browseOffplan: (name) => `${name} में ऑफ-प्लान देखें →`,
    viewResale: 'रिसेल संपत्तियां देखें →',
    priceTrendBadge: 'कीमत रुझान',
    priceTrendTitle: '12 माह का प्रति वर्ग फुट मूल्य (AED)',
    priceTrendSub: 'बाज़ार डेटा एकत्रीकरण पर आधारित 12 माह का रुझान',
    rentalYieldBadge: 'किराया उपज',
    rentalYieldTitle: 'क्षेत्र अनुसार सकल किराया उपज (%)',
    rentalYieldSub: 'औसत वार्षिक किराया बनाम औसत खरीद मूल्य पर आधारित',
    tooltipYield: (val, name) => [`${val}% सकल उपज`, name],
    comparisonBadge: 'क्षेत्र तुलना',
    comparisonTitle: 'अधिकतम 3 क्षेत्रों की तुलना करें',
    comparisonSub: 'तुलना के लिए नीचे से क्षेत्र चुनें',
    comparisonPlaceholder: 'तुलना देखने के लिए ऊपर से क्षेत्र चुनें',
    colMetric: 'मेट्रिक',
    rowAvgPrice: 'औसत कीमत',
    rowPricePerSqft: 'कीमत / वर्ग फुट',
    rowGrossYield: 'सकल उपज',
    rowDemandScore: 'मांग स्कोर',
    rowActiveProjects: 'सक्रिय परियोजनाएं',
    rowMinEntry: 'न्यूनतम प्रवेश कीमत',
    rowMaxPrice: 'अधिकतम कीमत',
    best: 'सर्वश्रेष्ठ',
    metricAvgPrice: 'औसत कीमत',
    metricRentalYield: 'किराया उपज',
    metricDemand: 'मांग',
    metricPricePerSqft: 'कीमत/वर्ग फुट',
  },
  hero: {
    slide1H: 'जहाँ स्मार्ट डेटा, विशेषज्ञ मार्गदर्शन और विश्वास एक साथ मिलते हैं।',
    slide1P: 'Victory Homes UAE का पहला ब्रोकरेज है जो लोगों को घर खोजने से पहले उनका सपनों का जीवन खोजने में मदद करता है।',
    slide1Btn: 'अभी देखें',
    slide2H: 'एक्सक्लूसिव वॉटरफ्रंट एस्टेट।',
    slide2P: 'Palm Jumeirah — दुनिया के सबसे प्रसिद्ध कृत्रिम द्वीप पर अतुलनीय विलासिता का अनुभव करें।',
    slide2Btn: 'Palm देखें',
    slide3H: 'भविष्य का जीवन, सही मिलान।',
    slide3P: 'पर्यावरण डेटा और भविष्यवाणी मॉडलिंग का उपयोग करके, हम लोगों को Dubai Marina के अनूठे समुदायों से जोड़ते हैं।',
    slide3Btn: 'Marina देखें',
    slide4H: 'घर नहीं, जीवन खोजें।',
    slide4P: 'District One में प्रसिद्ध Crystal Lagoon और सुंदर हरियाली से घिरे एक निजी आश्रय की खोज करें।',
    slide4Btn: 'District One देखें',
  },
  stats: {
    impact: 'हमारा व्यावसायिक प्रभाव',
    sold: 'कुल बिक्री 2020–2024',
    lifetime: 'जीवनकाल बिक्री मात्रा',
    current: 'वर्तमान लिस्टिंग मात्रा',
  },
  sellTestimonials: {
    tag: 'ग्राहक समीक्षाएं',
    heading: 'Victory Homes के साथ तेज़ और कुशल तरीके से बेचें',
    desc: 'एक सरल, पारदर्शी प्रक्रिया जो आपकी संपत्ति का मूल्य अधिकतम करती है। स्मार्ट तरीके से बेचें।',
  },
  team: {
    tag: 'हमारी टीम',
    heading: 'अमीरात के शीर्ष रियल एस्टेट विशेषज्ञों से जुड़ें',
    desc: 'Victory Homes के हमारे समर्पित एजेंट्स से मिलें — हर कदम पर आपका मार्गदर्शन करने के लिए तैयार।',
    btn: 'पूरी टीम से मिलें →',
  },
  goldenVisa: {
    badge: '🇦🇪 निवेशक लाभ',
    heading: 'UAE गोल्डन वीज़ा',
    headingGold: 'संपत्ति के माध्यम से',
    desc: 'UAE में <strong>AED 20 लाख या उससे अधिक</strong> का निवेश करें और <strong>10 साल का नवीनीकरणीय UAE रेज़िडेंसी वीज़ा</strong> पाएं — आपके और आपके परिवार के लिए।',
    cta: 'मेरी पात्रता जाँचें →',
    benefitsHeading: 'गोल्डन वीज़ा क्यों है गेम-चेंजर',
    benefitsSubheading: 'UAE गोल्डन वीज़ा वे दरवाज़े खोलता है जो अधिकांश देश नहीं खोलते।',
    stepsHeading: 'गोल्डन वीज़ा कैसे प्राप्त करें',
    stepsSubheading: '4 सरल चरण — हमारी टीम हर एक में आपका मार्गदर्शन करती है',
    stepCtaHeading: 'UAE गोल्डन वीज़ा सुरक्षित करने के लिए तैयार हैं?',
    stepCtaDesc: 'हमारे सलाहकार आपके बजट और लक्ष्यों के लिए सही संपत्ति खोजेंगे।',
    stepCtaBtn: 'सलाहकार से बात करें',
    yearVisa: 'साल का वीज़ा',
    minValue: 'न्यूनतम संपत्ति मूल्य',
    benefits: {
      b1t: '10 साल की रेज़िडेंसी', b1d: 'AED 20 लाख या उससे अधिक की संपत्ति में निवेश करके दशकभर का UAE गोल्डन वीज़ा सुरक्षित करें।',
      b2t: 'परिवार प्रायोजन', b2d: 'पत्नी, बच्चे और माता-पिता को एक ही वीज़ा के तहत प्रायोजित करें।',
      b3t: 'कोई प्रायोजक आवश्यक नहीं', b3d: 'नियोक्ता या स्थानीय प्रायोजक की ज़रूरत के बिना UAE में रहें, काम करें और पढ़ें।',
      b4t: 'अनिश्चितकाल नवीनीकरणीय', b4d: 'जब तक आपके पास योग्य संपत्ति है, गोल्डन वीज़ा स्वचालित रूप से नवीनीकृत होता है।',
      b5t: 'वैश्विक गतिशीलता', b5d: 'मल्टी-एंट्री विशेषाधिकार और वीज़ा वैधता खोए बिना UAE के बाहर लंबे समय तक रहने का आनंद लें।',
      b6t: 'निवेश सुरक्षा', b6d: 'UAE संपत्ति एक Tier-1 संपत्ति वर्ग है — उच्च रेज़िडेंसी को मजबूत पूंजी वृद्धि के साथ जोड़ें।',
    },
    steps: {
      s1: 'AED 20 लाख या उससे अधिक की संपत्ति खरीदें',
      s2: 'Dubai Land Department से Title Deed प्राप्त करें',
      s3: 'हमारी टीम के मार्गदर्शन में ICA या GDRFA के माध्यम से आवेदन करें',
      s4: 'अपना 10 साल का गोल्डन वीज़ा और Emirates ID प्राप्त करें',
    },
  },
  blog: {
    tag: 'ब्लॉग',
    heading: 'अमीरात रियल एस्टेट ब्लॉग से अंतर्दृष्टि और समाचार',
    desc: 'Dubai रियल एस्टेट पर नवीनतम बाज़ार समाचार, टिप्स और विशेषज्ञ अंतर्दृष्टि प्राप्त करें।',
    readMore: 'पढ़ना जारी रखें',
  },
  evo: {
    statsBadge: 'संख्याओं में दुबई',
    statsHeading: 'दुबई का रियल एस्टेट विकास',
    statsDesc: 'एक क्षेत्रीय व्यापार बंदरगाह से दो दशकों में दुनिया के सबसे गतिशील संपत्ति बाज़ार तक।',
    timelineBadge: 'कहानी',
    timelineHeading: 'दुबई कैसे बना दुनिया का #1 रियल एस्टेट गंतव्य',
    timelineCTA: 'जानना चाहते हैं कि दुबई का बाज़ार आगे कहाँ जाएगा?',
    timelineBtn: 'बाज़ार विशेषज्ञ से बात करें →',
    stats: {
      s1l: '2024 में संपत्ति लेनदेन', s2l: '2024 में AED कुल बिक्री मूल्य',
      s3l: '2020 से संपत्ति मूल्य वृद्धि', s4l: 'दुबई में रहने वाली राष्ट्रीयताएं',
    },
    timeline: {
      t1t: 'फ्रीहोल्ड कानून', t1d: 'दुबई ने विदेशियों को निर्धारित फ्रीहोल्ड क्षेत्रों में संपत्ति स्वामित्व की अनुमति दी।',
      t2t: 'क्षितिज परिवर्तन', t2d: 'Burj Khalifa खुला और दुबई दुनिया का सबसे मान्यता प्राप्त आधुनिक शहर बना।',
      t3t: 'गोल्डन वीज़ा शुरू', t3d: 'UAE ने 10 साल के गोल्डन वीज़ा कार्यक्रम की शुरुआत की।',
      t4t: 'रिकॉर्ड-तोड़ बाज़ार', t4d: 'महामारी के बाद की रिकवरी ने कीमतों में 60% से अधिक की वृद्धि की।',
      t5t: 'नए सर्वकालिक उच्च', t5d: 'दुबई ने AED 411 अरब मूल्य के 96,000+ लेनदेन दर्ज किए।',
      t6t: 'दुबई 2040 शहरी योजना', t6d: 'योजना 2040 तक हरित स्थानों को दोगुना करने और 5.8 मिलियन जनसंख्या का लक्ष्य रखती है।',
    },
  },
  txn: {
    badge: 'DXBinteract द्वारा संचालित',
    heading: 'दुबई लेनदेन रिपोर्ट',
    desc: 'Dubai Land Department का लाइव डेटा देखें — हर बिक्री दर्ज, हर कीमत ट्रैक, हर ट्रेंड मैप।',
    live: 'लाइव DLD डेटा',
    openPlatform: 'पूरा प्लेटफ़ॉर्म खोलें ↗',
    viewReport: 'रिपोर्ट देखें →',
    ctaHeading: 'किसी विशेष क्षेत्र के लिए व्यक्तिगत लेनदेन रिपोर्ट चाहते हैं?',
    ctaDesc: 'हमारे सलाहकार क्षेत्र-विशिष्ट डेटा निकाल सकते हैं और आपके निवेश के लिए उसकी व्याख्या कर सकते हैं।',
    ctaBtn: 'सलाहकार से पूछें',
    reports: {
      r1l: 'दैनिक रिपोर्ट', r1d: 'DLD द्वारा दर्ज हर लेनदेन — दैनिक अपडेट।',
      r2l: 'साप्ताहिक रिपोर्ट', r2d: 'बिक्री मात्रा, कीमतों और क्षेत्र रुझानों का साप्ताहिक सारांश।',
      r3l: 'मासिक रिपोर्ट', r3d: 'सभी संपत्ति प्रकारों में मासिक प्रदर्शन का गहन विश्लेषण।',
      r4l: 'त्रैमासिक रिपोर्ट', r4d: 'तिमाही विश्लेषण: मूल्य बदलाव, शीर्ष क्षेत्र, निवेशक गतिविधि।',
      r5l: 'वार्षिक रिपोर्ट', r5d: 'पूर्ण वर्ष बाज़ार अवलोकन: रिकॉर्ड सौदे, उभरते समुदाय, पूर्वानुमान।',
      r6l: 'क्षेत्र मूल्य मानचित्र', r6d: 'सभी दुबई समुदायों में प्रति वर्ग फुट मूल्य दिखाने वाला इंटरैक्टिव हीटमैप।',
    },
  },
  cta: {
    buying: 'खरीदना शुरू करें', selling: 'बेचना शुरू करें', contact: 'संपर्क करें',
    findOut: 'और जानें', comingSoon: 'जल्द आ रहा है',
  },
  offplanPromo: {
    badge: 'ऑफ-प्लान संपत्तियाँ',
    heading: 'नए प्रोजेक्ट और एक्सक्लूसिव प्री-लॉन्च डील',
    desc: 'दुबई के सबसे लोकप्रिय ऑफ-प्लान डेवलपमेंट में इकाइयाँ सुरक्षित करें — बिकने से पहले। AED 20 लाख से गोल्डन वीज़ा पात्र।',
    btn: 'ऑफ-प्लान देखें →',
  },
  topCommunities: {
    badge: 'बाज़ार अंतर्दृष्टि (Market Insights)',
    heading: 'दुबई की शीर्ष कम्युनिटीज़',
    desc: 'निवेशकों और घर खरीदारों के लिए रणनीतिक जानकारी (2026-2027)',
    tabs: {
      roi: 'आरओआई लीडर्स',
      villas: 'विला और टाउनहाउस',
      budget: 'बजट के अनुसार',
      strategy: 'रणनीति गाइड'
    },
    roi: {
      title: 'आरओआई के लिए शीर्ष कम्युनिटीज़ (2026–2027)',
      desc: 'ये क्षेत्र लगातार बेहतरीन रेंटल यील्ड और प्रॉपर्टी की कीमत में वृद्धि देते हैं।',
      list: [
        'जुमेराह विलेज सर्किल (JVC)',
        'दुबई साउथ',
        'अर्जन',
        'दुबई सिलिकॉन ओएसिस',
        'दुबई स्पोर्ट्स सिटी',
        'बिजनेस बे',
        'दुबई मरीना'
      ],
      insightTitle: 'मुख्य तथ्य',
      insights: [
        'JVC + अर्जन = सबसे अधिक उपज (6–9%)',
        'मरीना + बिजनेस बे = कम उपज लेकिन बेहतर कीमत वृद्धि + तरलता'
      ]
    },
    villas: {
      title: 'विला / टाउनहाउस के लिए सर्वश्रेष्ठ कम्युनिटीज़',
      desc: 'परिवारों और दीर्घकालिक निवास के लिए आदर्श।',
      list: [
        'दुबई हिल्स एस्टेट',
        'अरेबियन रेंचेस',
        'तिलाल अल गफ',
        'डैमैक हिल्स',
        'द वैली',
        'मुदोन',
        'टाउन स्क्वायर'
      ],
      insightTitle: 'मुख्य तथ्य',
      insights: [
        'दुबई हिल्स = सबसे अच्छा संतुलन (स्थान + गुणवत्ता)',
        'तिलाल अल गफ = लक्ज़री लाइफस्टाइल कम्युनिटी',
        'टाउन स्क्वायर / द वैली = एंट्री-लेवल विला'
      ]
    },
    budget: {
      title: 'बजट के अनुसार सर्वश्रेष्ठ कम्युनिटीज़',
      categories: [
        {
          name: 'एंट्री-लेवल',
          range: 'AED 500K – 900K',
          areas: ['इंटरनेशनल सिटी', 'दुबई साउथ', 'डिस्कवरी गार्डन्स', 'दुबई प्रोडक्शन सिटी', 'लिवान'],
          bestFor: 'पहली बार निवेश करने वालों के लिए, उच्चतम किराये की उपज'
        },
        {
          name: 'मिड-मार्केट',
          range: 'AED 900K – 2M',
          areas: ['जुमेराह विलेज सर्किल', 'अर्जन', 'अल फुरजान', 'दुबई सिलिकॉन ओएसिस', 'दुबई क्रीक हार्बर'],
          bestFor: 'आरओआई + कीमत वृद्धि का संतुलन'
        },
        {
          name: 'अपर-मिड / प्रीमियम',
          range: 'AED 2M – 5M',
          areas: ['बिजनेस बे', 'दुबई मरीना', 'दुबई हिल्स एस्टेट', 'पाम जुमेराह (शुरुआती इकाइयाँ)'],
          bestFor: 'तरलता + मजबूत पुनर्विक्रय मांग (रीसेल डिमांड)'
        },
        {
          name: 'लक्ज़री',
          range: 'AED 5M+',
          areas: ['डाउनटाउन दुबई', 'पाम जुमेराह', 'अमीरात हिल्स', 'डिस्ट्रिक्ट वन', 'जुमेराह बे द्वीप'],
          bestFor: 'पूंजी संरक्षण + प्रतिष्ठित संपत्तियां'
        }
      ]
    },
    strategy: {
      title: 'सरल रणनीति गाइड',
      guide: [
        { goal: 'अधिकतम आरओआई', action: 'JVC, अर्जन, दुबई साउथ' },
        { goal: 'सुरक्षित निवेश', action: 'दुबई हिल्स, मरीना' },
        { goal: 'लक्ज़री कीमत वृद्धि', action: 'पाम जुमेराह, डाउनटाउन' },
        { goal: 'पारिवारिक जीवन', action: 'अरेबियन रेंचेस, तिलाल अल गफ' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "विक्ट्री सेवाएँ",
    "whyChoose": "हमारा {service} क्यों चुनें?",
    "form": {
        "fullName": "पूरा नाम",
        "email": "ईमेल एड्रेस",
        "phone": "फ़ोन नंबर",
        "detailsOpt": "संपत्ति/यूनिट विवरण (वैकल्पिक)",
        "messageOpt": "अतिरिक्त संदेश या आवश्यकताएं",
        "submitRequest": "सबमिट करें",
        "submitting": "सबमिट हो रहा है...",
        "successTitle": "अनुरोध प्राप्त हो गया!",
        "successDesc": "हमारी {service} के बारे में संपर्क करने के लिए धन्यवाद। हमारी टीम आपसे जल्द ही संपर्क करेगी।",
        "submitAnother": "एक और अनुरोध सबमिट करें",
        "errors": {
            "nameReq": "कृपया अपना पूरा नाम दर्ज करें",
            "emailReq": "कृपया एक वैध ईमेल पता दर्ज करें",
            "phoneReq": "कृपया अपना फ़ोन नंबर दर्ज करें",
            "failSub": "सबमिट करने में विफल। कृपया बाद में फिर से प्रयास करें।"
        },
        "placeholders": {
            "name": "उदा: जॉन डो",
            "email": "you@example.com",
            "phone": "+971 50 123 4567",
            "details": "उदा: डाउनटाउन दुबई में 2 बेड का अपार्टमेंट",
            "message": "हम आपकी कैसे मदद कर सकते हैं?"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "हॉलिडे होम्स",
            "heroSub": "हमारे अल्पावधि रेंटल प्रबंधन के साथ अपनी संपत्ति का अधिकतम लाभ उठाएं।",
            "desc": "अपनी संपत्ति को बिना किसी परेशानी के लाभदायक हॉलिडे होम में बदलें। हम बेहतरीन रिटर्न सुनिश्चित करने के लिए मार्केटिंग, अतिथि प्रबंधन और रखरखाव को संभालते हैं।",
            "extraDesc": "फर्नीचर से लेकर पेशेवर फोटोग्राफी और वैश्विक प्लेटफार्मों पर सूचीकरण तक, हम पूरी प्रक्रिया संभालते हैं। हम आपको 24/7 अतिथि सहायता भी प्रदान करते हैं।",
            "points": [
                "डायनामिक मूल्य निर्धारण और मार्केटिंग",
                "24/7 अतिथि सहायता",
                "पेशेवर हाउसकीपिंग",
                "मासिक ROI रिपोर्टिंग",
                "कानूनी और पंजीकरण सहायता"
            ],
            "formTitle": "हॉलिडे होम सेवा का अनुरोध करें",
            "formDesc": "हमें बताएं कि हम आपके रेंटल लक्ष्यों में कैसे सहायता कर सकते हैं।"
        },
        "property-management": {
            "title": "प्रॉपर्टी मैनेजमेंट",
            "heroSub": "मन की शांति और स्थिर आय के लिए व्यापक प्रबंधन सेवाएँ।",
            "desc": "किरायेदार की जांच से लेकर रखरखाव के अनुरोधों तक, हमारी टीम पेशेवर रूप से आपके निवेश का प्रबंधन करती है।",
            "extraDesc": "हम मकान मालिक होने के दिन-प्रतिदिन के तनाव को दूर करते हैं। हमारी सेवा में एज़ारी पंजीकरण, किराया संग्रह, संपत्ति निरीक्षण और आपातकालीन मरम्मत शामिल हैं।",
            "points": [
                "व्यापक किरायेदार जांच",
                "किराया संग्रह और वित्तीय रिपोर्टिंग",
                "एज़ारी और कानूनी अनुपालन",
                "नियमित निरीक्षण और रखरखाव",
                "विवाद समाधान सेवाएँ"
            ],
            "formTitle": "प्रॉपर्टी मैनेजमेंट का अनुरोध करें",
            "formDesc": "अपना विवरण प्रदान करें और हम आपको एक अनुकूलित प्रबंधन योजना के साथ वापस कॉल करेंगे।"
        },
        "fit-out": {
            "title": "फिट-आउट सेवाएँ",
            "heroSub": "हमारे विश्व-स्तरीय इंटीरियर डिज़ाइन समाधानों के साथ अपने स्थान को बदलें।",
            "desc": "आवासीय और व्यावसायिक स्थानों के लिए कस्टम डिजाइन, योजना और निष्पादन।",
            "extraDesc": "हमारे अनुभवी डिजाइनर शुरू से अंत तक आपके साथ मिलकर काम करते हैं। हम गारंटी देते हैं कि आपका विज़न उच्चतम गुणवत्ता वाली सामग्री के साथ जीवित होगा।",
            "points": [
                "कस्टम इंटीरियर डिजाइन अवधारणाएँ",
                "स्पेस प्लानिंग और 3D विज़ुअलाइज़ेशन",
                "टर्नकी निष्पादन और परियोजना प्रबंधन",
                "प्राधिकरण अनुमोदन और परमिट",
                "कस्टम फर्नीचर और सामग्री स्रोत"
            ],
            "formTitle": "फिट-आउट परामर्श का अनुरोध करें",
            "formDesc": "अपनी संपत्ति के लिए अपनी दृष्टि पर चर्चा करने के लिए परामर्श का समय तय करें।"
        },
        "legal-assistance": {
          title: "कानूनी सहायता",
          heroSub: "यूएई में सुरक्षित अचल संपत्ति लेनदेन के लिए विशेषज्ञ कानूनी मार्गदर्शन।",
          desc: "दुबई के अचल संपत्ति कानूनों को नेविगेट करने के लिए सटीकता की आवश्यकता होती है। हम सुरक्षित लेनदेन के लिए पूर्ण कानूनी सहायता प्रदान करते हैं।",
          extraDesc: "पूरी तरह से शीर्षक सत्यापन से लेकर पूर्ण RERA अनुपालन सुनिश्चित करने तक, हमारे विशेषज्ञ आपके हितों की रक्षा करते हैं।",
          points: ["शीर्षक सत्यापन और देय परिश्रम", "RERA अनुपालन और मार्गदर्शन", "बिक्री विलेख चेकलिस्ट तैयारी", "संपत्ति खरीद सत्यापन", "विवाद समाधान"],
          formTitle: "कानूनी सहायता का अनुरोध करें",
          formDesc: "अपना विवरण प्रदान करें और हमारे कानूनी विशेषज्ञ आपसे संपर्क करेंगे।"
        }
    }
},
  footer: {
    letsWork: 'मिलकर काम करें',
    email: 'ईमेल',
    callWhatsApp: 'कॉल / व्हाट्सएप',
    ourLocation: 'हमारा स्थान',
    officePhone: 'कार्यालय फोन',
    tagline: 'दुबई में आपका विश्वसनीय रियल एस्टेट पार्टनर। पूरे UAE में प्रीमियम संपत्तियों की खरीद, बिक्री और किराये में माहिर।',
    ourServices: 'हमारी सेवाएं',
    usefulLinks: 'उपयोगी लिंक',
    copyright: '© 2025 Victory Homes. सर्वाधिकार सुरक्षित।',
    serviceLinks: ['नई संपत्तियाँ', 'अपनी संपत्ति बेचें', 'हमारी सेवाएं', 'प्रेस विज्ञप्ति'],
    headline: 'हमारी योग्य रियल एस्टेट एजेंटों की टीम हमेशा उपलब्ध है, कभी भी, कहीं भी।',
  },
  offplanDetail: {
    overview: "अवलोकन",
    propertyTypes: "संपत्ति के प्रकार",
    totalUnits: "कुल इकाइयाँ",
    handover: "कब्जा (हैंडओवर)",
    startingPrice: "शुरुआती कीमत",
    startingFrom: "से शुरू",
    paymentPlan: "भुगतान योजना",
    location: "स्थान और कनेक्टिविटी",
    mins: "मिनट",
    unitType: "इकाई प्रकार",
    size: "आकार",
    availableOptions: "उपलब्ध विकल्प",
    getBrochure: "ब्रोशर प्राप्त करें",
    reqDetails: "विवरण का अनुरोध करें",
    dlBrochure: "ब्रोशर डाउनलोड करें",
    dlFloorPlans: "फ्लोर प्लान डाउनलोड करें",
    fullName: "पूरा नाम *",
    emailAdd: "ईमेल पता *",
    phoneNum: "फ़ोन नंबर",
    reqDesc: "{name} के लिए पूरा प्रोजेक्ट {type} प्राप्त करने के लिए अपना विवरण भरें।",
    reqSuccess: "अनुरोध प्राप्त हुआ",
    reqSuccessDesc: "धन्यवाद। हमारे विशेषज्ञों में से एक जल्द ही आपको ब्रोशर और फ्लोर प्लान ईमेल करेगा।",
    close: "बंद करें",
    submitting: "जमा कर रहा है...",
    reqType: "{type} का अनुरोध करें",
    types: {
        Apartment: "अपार्टमेंट",
        Townhouse: "टाउनहाउस",
        Villa: "विला",
        Penthouse: "पेंटहाउस",
        Mansion: "हवेली",
        Duplex: "डुप्लेक्स",
        Plot: "प्लॉट"
    },
    tags: {
        waterfront: "वाटरफ्रंट",
        family: "परिवार",
        luxury: "लग्जरी",
        investment: "निवेश",
        golf: "गोल्फ कोर्स",
        urban: "शहरी",
        nature: "प्रकृति"
    },
    beds: {
        studio: "स्टूडियो",
        br: "बेडरूम",
        units: "इकाइयाँ",
        various: "विभिन्न"
    }
}
,
  offplanExtra: {
        "interested": "दिलचस्पी है?",
        "readyToSecure": "अपनी यूनिट सुरक्षित करने के लिए तैयार हैं:",
        "advisorGuide": "हमारे विशेषज्ञ सलाहकार मूल्य निर्धारण, भुगतान विकल्पों और पूरी खरीदारी प्रक्रिया में आपका मार्गदर्शन कर सकते हैं — बिना किसी कमीशन के।",
        "getInTouch": "संपर्क करें",
        "whatsapp": "व्हाट्सएप",
        "enquire": "पूछताछ करें",
        developer: "डेवलपर",
    community: "समुदाय",
    buildingHeight: "इमारत की ऊंचाई",
    retailSpace: "रिटेल स्पेस",
    furnishing: "फर्नीचर",
    about: "के बारे में",
    investmentOutlook: "निवेश दृष्टिकोण",
    lifestyle: "जीवन शैली",
    worldClassAmenities: "विश्व स्तरीय सुविधाएँ",
    unitTypes: "इकाई प्रकार",
    floorPlans: "फ्लोर प्लान",
    financing: "वित्तपोषण",
    typesSuffix: "प्रकार",
    sizeRange: "आकार सीमा",
    units: "इकाइयाँ",
    from: "से",
        ofTotalPayment: "कुल भुगतान का",
        whyOffPlan: "ऑफ-प्लान क्यों?",
        lowerEntryPrice: "तैयार संपत्तियों की तुलना में कम प्रवेश मूल्य",
        spreadPayments: "निर्माण के दौरान भुगतान फैलाएं",
        capitalAppreciation: "हैंडओवर से पहले पूंजी वृद्धि",
        zeroCommission: "0% कमीशन - सीधे खरीदें",
        speakToAdvisor: "सलाहकार से बात करें",
        openMap: "Google मानचित्र में सटीक स्थान खोलें",
        nearbyPlaces: "आस-पास के स्थान",
        to: "तक",
        booking: "बुकिंग",
        installment: "किश्त",
        handover: "हैंडओवर",
        areaUnit: "क्षेत्रफल इकाई",
        currency: "मुद्रा",
        youtubeLink: "यूट्यूब वीडियो लिंक",
        watchVideo: "वीडियो देखें",
        watchTour: "संपत्ति टूर देखें"
    },
  amenities: {
        "Kids Pool": "बच्चों का पूल",
        "Private Beach Access": "निजी समुद्र तट तक पहुंच",
        "Marina Access": "मरीना तक पहुंच",
        "Outdoor Gym": "आउटडोर जिम",
        "Basketball Court": "बास्केटबॉल कोर्ट",
        "Tennis Court": "टेनिस कोर्ट",
        "Padel Court": "पैडल कोर्ट",
        "Cycling Track": "साइकिलिंग ट्रैक",
        "Spa & Wellness Center": "स्पा और वेलनेस सेंटर",
        "Kids Play Area": "बच्चों के खेलने का क्षेत्र",
        "Clubhouse": "क्लब हाउस",
        "Library": "पुस्तकालय",
        "Retail Outlets": "खुदरा दुकानें",
        "Cafes & Restaurants": "कैफे और रेस्तरां",
        "Supermarket": "सुपरमार्केट",
        "Concierge Service": "कंसीयज सेवा",
        "24/7 Security": "24/7 सुरक्षा",
        "CCTV Surveillance": "सीसीटीवी निगरानी",
        "Mosque": "मस्जिद",
        "Pet Friendly": "पालतू जानवरों के अनुकूल",
        "Dining Destinations": "भोजन स्थल",
        "Yoga Studio": "योग स्टूडियो",
        "Lush Green Parks": "हरे-भरे पार्क",
        "Valet Parking": "वैलेट पार्किंग",
        "Smart Home Features": "स्मार्ट होम सुविधाएँ",
        "Sauna & Steam Room": "सौना और स्टीम रूम",
        "Covered Parking": "कवर पार्किंग",
        "Landscaped Gardens": "लैंडस्केप उद्यान",
    "Swimming Pool": "स्विमिंग पूल",
    "State-of-the-art Gym": "अत्याधुनिक जिम",
    "BBQ Area": "बारबेक्यू क्षेत्र",
    "Sports Courts": "खेल के मैदान",
    "Infinity Pool": "इन्फिनिटी पूल",
    "Running Track": "दौड़ने का ट्रैक",
    "Cinema Room": "सिनेमा कक्ष",
    "Games Room": "गेम्स रूम"
}
}

export default hi
